import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`

export const CardContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1284px;
    height: auto;
    margin: 82px 8px 40px 90px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius};
    position: relative;

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    @media print {
      margin: 0 !important;
      max-width: none;
    }
  `}
`

export const UseModelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 12px 36px;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18%;
    height: 36px;
  }

  ${media.lessThan('large')`
    > button {
      width: 28%;
    }
  `}

  ${media.lessThan('medium')`
    > button {
      width: 38%;
    }
  `}

  ${media.lessThan('small')`
    > button {
      width: 100%;
    }
  `}
`

export const CardContent = styled.div`
  padding: 20px 40px;

  ${media.lessThan('small')`
    padding: 8px;
  `}
`

export const Resume = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 34px 40px 34px;
`

export const TextareaContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 530px;
`

export const TextareaButtonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    margin-left: 12px;

    .help-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${theme.colors.black};
      color: ${theme.colors.white};
      font-size: ${theme.font.sizes.normal};
      border-radius: 50%;
      height: 24px;
      width: 24px;
      cursor: pointer;

      > svg {
        margin: -2px;
      }
    }

    .tooptip-custom {
      width: 100%;
      background: ${theme.colors.white} !important;
      opacity: 1 !important;
      text-align: left;
      max-width: 260px;
      box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
      border-radius: ${theme.border.radius};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
    }
  `}
`

export const DateContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

export const ButtonAddTestContainer = styled.div`
  padding: 24px 32px;

  > button {
    max-width: 297px;
    position: relative;

    .initial-icon {
      position: absolute;
      left: 15px;
    }

    .end-icon {
      position: absolute;
      right: 20px;
      top: 22px;
    }
  }

  ${media.lessThan('small')`
    .initial-icon,
    .end-icon {
      display: none;
    }
  `}
`

export const DropdownContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 389px;
    height: 300px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.radius} ${theme.border.radius} 0 0;
    padding: 0 14px;
    overflow: auto;

    div {
      margin-bottom: 20px;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }
  `}
`

export const ButtondropdownContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    max-width: 389px;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 ${theme.border.radius} ${theme.border.radius};
    padding: 8px 60px;
  `}
`

export const ButtonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;

    margin-bottom: 30px;
    margin-left: 32px;
    gap: 6px;
    width: 60%;

    > p {
      position: absolute;
      right: 36px;
      bottom: 30px;
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.semiBold};
    }

    .button-save {
      max-width: 180px;
      position: relative;

      > svg {
        position: absolute;
        left: 20px;
      }
    }

    .button-printer {
      max-width: 180px;
      position: relative;

      > svg {
        position: absolute;
        left: 20px;
      }
    }

    .button-return-to-list {
      max-width: 256px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;

      > a {
        text-align: center;
        text-decoration: none;
        width: 100%;
        padding: 0.8rem;
        border-radius: ${theme.border.radius};
        color: ${theme.colors.darkGray};
      }

      > svg {
        position: absolute;
        left: 10px;
      }
    }

    ${media.lessThan('medium')`
      width: 90%;
      justify-content: space-between;

      p{
        display: none;
      }

      .button-return-to-list {
        svg {
          display: none;
        }
      }

      .button-printer {
        svg {
          display: none;
        }
      }

      .button-save {
        svg {
          display: none;
        }
      }
    `}

    ${media.lessThan('small')`
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 8px;

      .button-save{
        margin-bottom: 20px;

        svg {
          display: flex;
        }
      }

      .button-printer {
        svg {
          display: flex;
        }
      }

      .button-return-to-list{
        max-width: 200px;
        text-align: center;

        svg {
          display: flex;
        }
      }
    `}
  `}
`
